import { render, staticRenderFns } from "./systemReleaseForAdmin.vue?vue&type=template&id=78514adc&scoped=true&"
import script from "./systemReleaseForAdmin.vue?vue&type=script&lang=js&"
export * from "./systemReleaseForAdmin.vue?vue&type=script&lang=js&"
import style0 from "./systemReleaseForAdmin.vue?vue&type=style&index=0&id=78514adc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78514adc",
  null
  
)

export default component.exports